import React from 'react';
import { Flex } from '@components/Flex';
import { getRootUrl } from '@utils/urlHelpers.util';
import { CatalogStorefront } from '@utils/storefront/storefront.types';
import { useShopStorefrontContext } from '@utils/storefront/ShopStorefrontProvider';
import { StyledBannerContainer, DesktopWrapper, StyledNavButton, StyledFlex, StyledText } from './UniversalNav.styles';
import { useTranslation } from 'react-i18next';
import { LanguageMenu } from '@components/LanguageMenu';

interface UniversalNavProps {
  variant?: 'blue' | 'default';
  page?: MarcomPageName;
}

export const UniversalNav: React.FC<UniversalNavProps> = ({ page, variant = 'default' }) => {
  const { currentStorefront } = useShopStorefrontContext();
  const { t } = useTranslation('header');

  return (
    <>
      <StyledBannerContainer variant={variant}>
        <Flex>
          <StyledNavButton
            active={currentStorefront === CatalogStorefront.wedding && page !== 'find'}
            id="universalNavWeddingBtn"
            variant="defaultPrimary"
            forwardedAs={'a'}
            href={getRootUrl('/')}
          >
            {t('universalNav.joyWedding')}
          </StyledNavButton>
          <StyledNavButton
            active={currentStorefront === CatalogStorefront.baby}
            id="universalNavBabyBtn"
            variant="defaultPrimary"
            forwardedAs={'a'}
            href={getRootUrl('/baby-registry/')}
          >
            <StyledFlex alignItems="center">
              <Flex as="span">{t('universalNav.joyBaby')}</Flex>
              <StyledText variant="dek20" color="mono1" tagName="span">
                {t('universalNav.new')}
              </StyledText>
            </StyledFlex>
          </StyledNavButton>
        </Flex>
        <DesktopWrapper>
          <StyledNavButton
            active={page === 'find'}
            id="universalNavFindAnEventBtn"
            variant="defaultPrimary"
            forwardedAs={'a'}
            href={getRootUrl('/find/')}
          >
            {t('universalNav.findAnEvent')}
          </StyledNavButton>
          <StyledNavButton id="universalNavLanguageMenuBtn" active={false}>
            <LanguageMenu />
          </StyledNavButton>
        </DesktopWrapper>
      </StyledBannerContainer>
    </>
  );
};
